var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "40px",
    viewBox: "0 0 52 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Hamburger_2235852") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1561.000000, -556.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Hamburger_2235852",
    transform: "translate(1561.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9,0 L4.1,0 C2.16700338,0 0.6,1.56700338 0.6,3.5 C0.6,5.43299662 2.16700338,7 4.1,7 L47.9,7 C49.8329966,7 51.4,5.43299662 51.4,3.5 C51.4,1.56700338 49.8329966,0 47.9,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,16.5 L4.1,16.5 C2.16700338,16.5 0.6,18.0670034 0.6,20 C0.6,21.9329966 2.16700338,23.5 4.1,23.5 L47.9,23.5 C49.8329966,23.5 51.4,21.9329966 51.4,20 C51.4,18.0670034 49.8329966,16.5 47.9,16.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,36.5 C51.4,34.5670034 49.8329966,33 47.9,33 L4.1,33 C2.16700338,33 0.6,34.5670034 0.6,36.5 C0.6,38.4329966 2.16700338,40 4.1,40 L47.9,40 C49.8329966,40 51.4,38.4329966 51.4,36.5 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.78dae36a1318ac4412cb83711bed970a.svg";
export { ForwardRef as ReactComponent };